module.exports = __webpack_public_path__ + "manageStatic/img/guanfang.31655008.png";